module.exports = __webpack_public_path__ + "static/media/ship-video.1b714362.png";